import * as React from 'react';
import {client} from '@logilab/cwclientlibjs';
import {useQuery} from './useQuery';
import {QueryTextInput} from './QueryInput';
import {TableQueryResults, QueryError} from './QueryResults';
/**
 * Parameters for the RQL querier component
 */
export interface StandaloneRqlQuerierProps {
    /**
     * The RQL client to use
     */
    client: client.RqlClient;
}
/**
 * Standalone RQL querier
 */
export const StandaloneRqlQuerier: React.FC<StandaloneRqlQuerierProps> = ({
    client,
}) => {
    const {query, setQuery, resultsAndVariables, executeQuery} = useQuery({
        rqlClient: client,
    });
    const {results, variables} = resultsAndVariables;
    let resultDisplay = null;
    if (results !== null) {
        if (results.status === 'error') {
            resultDisplay = <QueryError reason={results.reason} />;
        } else {
            resultDisplay = (
                <TableQueryResults
                    rows={results.rows}
                    queryVariables={variables}
                />
            );
        }
    }

    return (
        <div className="rql-querier">
            <QueryTextInput query={query} onQueryChange={setQuery} />
            <button className="execute-button" onClick={executeQuery}>
                execute
            </button>
            <div className="results">{resultDisplay} </div>
        </div>
    );
};
